import { Drawer as AntDrawer } from "ant-design-vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
	components: {
		AntDrawer
	}
})
export default class Drawer extends Vue {}
